import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/product';
export function Testimonials() {
  return <section className="bg-navy2 px-4 py-4 sm:py-6" data-id="element-175" data-mp="3kqw54mwtl6h6">
      <div className="mx-auto max-w-4xl" data-id="element-176" data-mp="3fze45yusr5w7">
        <h2 className="text-center text-lg leading-tight text-white sm:text-3xl" data-id="element-177" data-mp="3fy2z7vpm7s3i">
          WHAT MAINTENANCE TECHNICIANS SAY
        </h2>

        <div className="mt-2 grid gap-1.5 sm:grid-cols-2" data-id="element-178" data-mp="36yzfcpimj8ny">
          {testimonials.map((testimonial, i) => <figure key={testimonial.name} className={`flex flex-col rounded-md border border-white/15 bg-white/[0.05] p-2.5 ${i === 0 ? 'sm:col-span-2 sm:border-volt/50' : ''}`} data-id="element-179" data-mp="3205z4pbyd3k3" data-mpi={i}>
              <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-180" data-mp="2s39syq9j0tip">
                {Array.from({
              length: 5
            }).map((_, star) => <StarIcon key={star} className="h-3.5 w-3.5 fill-volt text-volt" aria-hidden="true" data-id="element-181" data-mp="qalipwygt5tf" data-mpi={star} />)}
              </div>
              <blockquote className="mt-1 text-[13px] font-medium leading-snug text-white/85" data-id="element-182" data-mp="m5b59r5dlyje">
                “{testimonial.quote}”
              </blockquote>
              <figcaption className="mt-auto pt-1.5" data-id="element-183" data-mp="7a4xozqmtrny">
                <p className="font-head text-[14px] font-bold uppercase tracking-wide text-volt" data-id="element-184" data-mp="c7wnno7pv3pi">
                  {testimonial.name}
                </p>
                <p className="text-[11px] font-semibold leading-tight text-white/75" data-id="element-185" data-mp="14vj2jsme9uro">
                  {testimonial.role}
                </p>
                <p className="text-[11px] font-medium leading-tight text-white/55" data-id="element-186" data-mp="q5lct88tgx0d">
                  {testimonial.location}
                </p>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}